import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { platformSelect } from '@bubble-ui/util-platform';
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    interactiveState,
    isActionIcon,
    isActive,
    leftAvatar,
    LeftIcon,
    rightAvatar,
    RightIcon
  } = _ref;
  var activeState = isActive ? 'active' : 'default';
  var backgroundColor = designContext.get('chip/background-color', {
    activeState,
    interactiveState
  });
  var borderColor = designContext.get('chip/border-color', {
    activeState,
    interactiveState
  });
  var textColor = designContext.get('chip/text-color', {
    activeState,
    interactiveState
  });
  var borderRadius = designContext.get('chip/corner-radius').pixelValue;
  var height = designContext.get('chip/height');
  var textStyle = designContext.get('chip/text-style', {
    activeState
  });
  return {
    buttonStyle: _objectSpread({
      border: 'none',
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      outline: 'none'
    }, interactiveState === 'disabled' ? {} : {
      cursor: 'pointer'
    }),
    rootStyle: {
      backgroundColor: backgroundColor.toString(),
      borderRadius,
      borderWidth: 1,
      borderColor: borderColor.toString(),
      height: height.value(),
      transition: 'background-color .2s ease, border-color .2s ease',
      position: 'relative',
      flexDirection: 'row',
      justifyContent: 'center',
      boxSizing: 'border-box',
      paddingLeft: leftAvatar ? 3 : LeftIcon && isActionIcon ? 10 : 15,
      paddingRight: rightAvatar ? 3 : RightIcon && isActionIcon ? 10 : 15,
      alignItems: 'center'
    },
    iconColor: {
      colorToken: 'chip/text-color',
      colorTokenArgs: {
        activeState,
        interactiveState
      }
    },
    avatarProps: {
      disabled: interactiveState === 'disabled',
      size: 32
    },
    textStyle: _objectSpread(_objectSpread(_objectSpread({}, platformSelect({
      native: {},
      default: {
        display: '-webkit-box',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        WebkitBoxOrient: 'vertical',
        WebkitFontSmoothing: 'antialiased',
        WebkitLineClamp: '1'
      }
    })), {}, {
      color: textColor.toString(),
      transition: 'color .2s ease'
    }, textStyle.styles()), {}, {
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'left',
      wordBreak: 'break-word'
    }),
    textWrapperStyle: {
      flexShrink: 1,
      paddingLeft: LeftIcon && isActionIcon ? 6 : LeftIcon || leftAvatar ? 10 : 0,
      paddingRight: RightIcon && isActionIcon ? 6 : RightIcon || rightAvatar ? 10 : 0,
      paddingTop: 0
    },
    keyboardFocusStyle: {
      position: 'absolute',
      borderColor: borderColor.toString(),
      borderStyle: 'solid',
      borderWidth: 2,
      borderRadius,
      top: -5,
      bottom: -5,
      left: -5,
      right: -5,
      transition: 'border-color .2s ease'
    }
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map